





























import {Vue, Component} from 'vue-property-decorator';
import Footers from '@/components/Footers.vue';
import {refreshToken} from '@/utils/dataUtils';
import Logo from '@/components/common/Logo.vue';

@Component({
  name: 'NoPermission',
  components: { Logo, Footers}
})
export default class NoPermission extends Vue {
  created() {
    refreshToken();
  }
}
